export default __webpack_public_path__ + "static/media/pillAtom.57ba091f.svg";